import type { UserType } from '@econtractor/types';

interface UserTeamItemProps {
    user: UserType;
}

const UserTeamItem = ({ user }: UserTeamItemProps) => {
    const teamName = user.access?.role === 'executor' ? String(user.teamName || '').trim() : '';
    if (!teamName) return <span className="text-muted">—</span>;

    return (
        <span className="text-body text-truncate d-inline-block w-100" title={teamName}>
            {teamName}
        </span>
    );
};

export default UserTeamItem;
